// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';

import { useAuth } from './AuthContext';

import Layout from './Layout';
import Auth from './Auth';

import Dashboard from './Dashboard';
import Participants from './Participants';
import ParticipantProfile from './ParticipantProfile';
import Invoices from './Invoices';
import UserInfo from './UserInfo';
import Agreements from './Agreements';
import Reports from './Reports';
import TimeTracking from './TimeTracking';
import Account from './Account';
import Export from './Export';

import AdminDashboard from './Admin';

const PlaceholderPage = ({ title }) => (
  <Typography variant="h4" sx={{ p: 3 }}>
    {title} (Coming Soon)
  </Typography>
);

const FullPageLoader = ({ text = 'Loading...' }) => (
  <Box
    sx={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      gap: 2,
    }}
  >
    <CircularProgress />
    <Typography variant="body2" color="text.secondary">
      {text}
    </Typography>
  </Box>
);

const ProtectedRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();
  if (loading) return <FullPageLoader text="Checking your session..." />;
  return currentUser ? children : <Navigate to="/signup" replace />;
};

const AdminRoute = ({ children }) => {
  const { currentUser, loading, isAdmin } = useAuth();
  if (loading) return <FullPageLoader text="Checking your permissions..." />;
  if (!currentUser) return <Navigate to="/signup" replace />;
  return isAdmin ? children : <Navigate to="/" replace />;
};

function App() {
  return (
    <Router>
      <Routes>
        {/* Public */}
        <Route path="/login" element={<Auth />} />
        <Route path="/signup" element={<Auth />} />

        {/* Protected */}
        <Route
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route path="/" element={<Dashboard />} />
          <Route path="/participants" element={<Participants />} />
          <Route path="/participants/:id" element={<ParticipantProfile />} />
          <Route path="/invoices" element={<Invoices />} />
          <Route path="/user-info" element={<UserInfo />} />
          <Route path="/agreements" element={<Agreements />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/time-tracking" element={<TimeTracking />} />
          <Route path="/reports-analytics" element={<PlaceholderPage title="Reports & Analytics" />} />
<Route path="/account" element={<Account />} />
<Route path="/export" element={<Export />} />

          {/* ✅ Admin protected */}
          <Route
            path="/admin"
            element={
              <AdminRoute>
                <AdminDashboard />
              </AdminRoute>
            }
          />
        </Route>

        {/* ✅ Catch-all */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;

